<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-expansion-panel [expanded]="isExpanded">
	<mat-expansion-panel-header>
		<mat-panel-title>
			{{ title }}

			@if (tooltip) {
				<span
					class="icon-warning"
					[ngxTippy]="tooltip"
				></span>
			}
		</mat-panel-title>
	</mat-expansion-panel-header>

	<ng-content />
</mat-expansion-panel>
